import { Avatar } from '@loomhq/lens';
import React from 'react';

import { CLOUDFRONT_URI } from 'constants/routes';

const WorkspaceLogo = ({
  workspace,
  filePreview = null,
  size = 4,
  letter = '',
}) => {
  // the workspace that is passed in may be the selected workspace which isn't available
  // when the parent component initially loads so we need to return here just in case.
  const shouldShow = workspace?.id || filePreview || letter;

  if (!shouldShow) {
    return null;
  }

  if (filePreview) {
    return <Avatar size={size} imageSrc={filePreview} />;
  }

  if (workspace?.workspaceLogoPath) {
    const logo = `${CLOUDFRONT_URI}/${workspace.workspaceLogoPath}`;

    return <Avatar size={size} imageSrc={logo} />;
  }

  const avatarLetter = letter || workspace?.name?.charAt(0);

  return <Avatar size={size} letter={avatarLetter} />;
};

export default WorkspaceLogo;
